import dayjs from "dayjs";

export const reasonOptions = [
  { label: "Unexpected Expenditure", value: "expenditure" },
  { label: "Lost Job", value: "lostJob" },
  { label: "Income Reduction", value: "income" },
  { label: "Personal or Family Issues", value: "personal" },
  { label: "Increase in expenditure/bills", value: "increaseBill" },
  { label: "Other", value: "other" },
];

export const durationOptions = [
  { label: "1 Month", value: "1" },
  { label: "2 Months", value: "2" },
  { label: "3 Months", value: "3" },
  { label: "4+ Months", value: "4" },
  { label: "Don't Know", value: "dontknow" },
];

export const paymentOptions = [
  { label: "Yes, make a payment now", value: "yes" },
  {
    label: "No, but I can pay my arrears in full before the next instalment",
    value: "no",
  },
  { label: "None of the above", value: "none" },
];
export const installmentOptions = [
  { label: "Weekly", value: "weekly" },
  { label: "Fortnightly", value: "fortnightly" },
  { label: "Monthly", value: "monthly" },
  { label: "Quarterly", value: "quarterly" },
  { label: "Anually", value: "anually" },
];

export const customerCareNav = {
  logOut: true,
  links: [
    {
      id: "1",
      url: "/customer-care",
      text: "Customer Care Home",
    },
    {
      id: "2",
      url: "/customer-care/advice",
      text: "Advice",
    },
  ],
};

export const employmentStautusOptions = [
  { label: "Full-time", value: "full-time" },
  { label: "Part-time", value: "part-time" },
  { label: "Self-employed", value: "self-employed" },
  { label: "Retired", value: "retired" },
  { label: "Carer", value: "carer" },
  { label: "Student", value: "student" },
  { label: "Illness or Disability", value: "illness-or-disability" },
  { label: "Unemployed", value: "unemployed" },
  { label: "Other", value: "other" },
];

export const clearCustomerData = () => {
  removeDataFromSessionStorage("appOAuth2Token");
  removeDataFromSessionStorage("loanAccountId");
  removeDataFromSessionStorage("popupVisited");
};

export function numberWithCommas(x) {
  return x && x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const setDataInSessionStorage = (key, value) => {
  try {
    typeof window !== "undefined" &&
      window.sessionStorage.setItem(key, JSON.stringify(value));
  } catch (err) {
    console.error("Error while storing data to session storage", err);
  }
};

export const setDataInLocalStorage = (key, value) => {
  try {
    typeof window !== "undefined" &&
      window.localStorage.setItem(key, JSON.stringify(value));
  } catch (err) {
    console.error("Error while storing data to session storage", err);
  }
};

export const getDataFromSessionStorage = key => {
  try {
    const item =
      typeof window !== "undefined" && window.sessionStorage.getItem(key);
    return JSON.parse(item);
  } catch (err) {
    console.error("Error while getting data from session storage", err);
  }
};

export const getDataFromLocalStorage = key => {
  try {
    const item =
      typeof window !== "undefined" && window.localStorage.getItem(key);
    return JSON.parse(item);
  } catch (err) {
    console.error("Error while getting data from session storage", err);
  }
};

export const removeDataFromSessionStorage = key => {
  try {
    typeof window !== "undefined" && window.sessionStorage.removeItem(key);
  } catch (err) {
    console.error("Error while removing data from session storage", err);
  }
};

export const UK_GBP_CONVERT = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const formatArrearDate = (date, format = "D MMMM YYYY") =>
  dayjs(date).format(format);

export const filterAddresses = addresses => {
  const companyRegex = /(?:\b(ltd|llp|plc|limited)[a-zA-Z]*[\s.,]*\b)/i;
  const companyFilteredAddresses = addresses.filter(item => {
    const finalAddress = [item.line_1, item.line_2, item.line_3]
      .filter(part => part.trim() !== "")
      .join(", ");

    // Filter companies having Ltd,Llp ,LLP,Plc,Limited (case-insensitive)
    if (companyRegex.test(finalAddress)) {
      return false;
    }

    return true;
  });

  return companyFilteredAddresses;
};

export const displayFullAddress = addressData => {
  const { sub_building_name, building_name, building_number, thoroughfare } =
    addressData;
  const addressLineArray = [];
  if (sub_building_name) {
    addressLineArray.push(sub_building_name);
  }

  if (building_name && !building_number && thoroughfare) {
    addressLineArray.push(`${building_name}`);
    addressLineArray.push(`${thoroughfare}`);
  } else if (building_name && building_number && thoroughfare) {
    addressLineArray.push(building_name);
    addressLineArray.push(`${building_number} ${thoroughfare}`);
  } else if (building_number && thoroughfare) {
    /*implicitly !building_name here*/ addressLineArray.push(
      `${building_number} ${thoroughfare}`,
    );
  } else if (thoroughfare) {
    /*implicitly !building_name && !building_number*/ addressLineArray.push(
      `${thoroughfare}`,
    );
  }

  addressLineArray.push(addressData.town_or_city);
  addressLineArray.push(addressData.postcode.toUpperCase());
  return addressLineArray.join(", ");
};
